module.exports = __webpack_public_path__ + "static/media/icon_angle-left-sm.fc6af53d.svg";